export const RECOGNIZE_BUTTON_BORDER_RADIUS = 6;
export const RECOGNIZE_BUTTON_GRADIENT =
  'linear-gradient(276.05deg, #68CAF3 -4.17%, #7723E5 33.57%, #EE49B1 74.47%, #FFCF53 104.71%)';
